import AbstractAccordion from '@/modules/common/common/models/APP/accordions/AbstractAccordion'
import Insurance from '@/modules/common/common/models/APP/Insurance'

export default class DentalInsurance extends Insurance {
  coverages: AbstractAccordion<any> | null

  constructor(data: Partial<DentalInsurance>) {
    super(data)

    this.coverages = data.coverages ?? null
  }
}
